export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/spss.105eb6e.svg";